import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { Box, Typography, SideDrawerWrapper } from '@the-platform-group/component-library'
import { DataGrid } from '@the-platform-group/component-library/DataGrid'
import { TruncatedText } from 'components/TruncatedText'
import { formatDateTimeToLocalDate } from 'utils/format'
import { formatDate } from '@the-platform-group/formatters/dateFormat'
import { TABLE_DATE_FORMAT } from 'constants/formats'
import FilesCell from 'pages/IrwinAssistant/Requests/components/FilesCell'
import useTemplateRequests from './hooks/useTemplateRequests'

const TABLE_NAME = 'tearsheetTemplateRequests'

const noop = () => {}

const columns = [
  {
    field: 'customer',
    headerName: 'Customer',
    valueGetter: ({ value }) => value?.name || '-',
  },
  {
    field: 'user',
    headerName: 'User',
    valueGetter: ({ value }) =>
      value ? `${value.firstName || ''} ${value.lastName || ''}`.trim() || '-' : '-',
  },
  {
    field: 'name',
    headerName: 'Request Name',
  },
  {
    field: 'message',
    headerName: 'Message',
    width: 280,
    flex: null,
    renderCell: ({ value }) => (
      <Box width="100%">
        <TruncatedText title="" content={value || ''} contentPreview={value || ''} maxLines={2} />
      </Box>
    ),
  },
  {
    field: 'filePaths',
    headerName: 'Files',
    valueGetter: ({ row }) => row,
    renderCell: ({ value }) => {
      if (isEmpty(value.filePaths)) return '-'
      return <FilesCell value={value} handleFileDownload={noop} getBulkDownloadUrl={noop} />
    },
  },
  {
    field: 'sentAt',
    headerName: 'Sent At',
    renderCell: ({ value }) => {
      if (!value) {
        return '-'
      }
      const localDate = formatDateTimeToLocalDate(value)
      return formatDate(localDate, TABLE_DATE_FORMAT)
    },
  },
]

const TearsheetTemplateRequestsTable = () => {
  const {
    requests,
    itemCount,
    isFetching,
    page,
    pageSize,
    pageSizeOptions,
    handlePageChange,
    handlePageSizeChange,
  } = useTemplateRequests()

  return (
    <Box
      sx={{
        height: 'calc(100vh - 112px)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ flexShrink: 0, py: 1 }}>
        <Typography variant="h4">Tearsheet Template Requests</Typography>
      </Box>
      <Box sx={{ flexGrow: 1, minHeight: 0 }}>
        <DataGrid
          name={TABLE_NAME}
          columns={columns}
          rows={requests}
          loading={isFetching}
          autoHeight={false}
          localeText={{ noRowsLabel: 'No tearsheet template requests found.' }}
          rowCount={itemCount}
          pageSize={pageSize}
          page={page}
          pageSizeOptions={pageSizeOptions}
          onPageSizeChange={handlePageSizeChange}
          onPageChange={handlePageChange}
        />
      </Box>
    </Box>
  )
}

const TearsheetTemplateRequests = () => (
  <SideDrawerWrapper>
    <TearsheetTemplateRequestsTable />
  </SideDrawerWrapper>
)

export default TearsheetTemplateRequests
